export default __webpack_public_path__ + "static/media/macncheese.badc8263.jpeg";